import { render, staticRenderFns } from "./TagCloudy.htm?vue&type=template&id=51985a3f&scoped=true&"
import script from "./TagCloudy.ts?vue&type=script&lang=js&"
export * from "./TagCloudy.ts?vue&type=script&lang=js&"
import style0 from "./TagCloudy.scss?vue&type=style&index=0&id=51985a3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51985a3f",
  null
  
)

export default component.exports